import {
  LIST_ERPS_INIT,
  LIST_ERPS_SUCCESS,
  CREATE_ERP_INIT,
  CREATE_ERP_SUCCESS,
  UPDATE_ERP_INIT,
  UPDATE_ERP_SUCCESS,
  DELETE_ERP_INIT,
  DELETE_ERP_SUCCESS,
  ADD_ERP_VERSAO_INIT,
  ADD_ERP_VERSAO_SUCCESS,
  ERPS_ERROR_MSG,
  CLEAR_FLAGS_ERPS
} from '../actionTypes';

export const listErpsInit = () => ({
  type: LIST_ERPS_INIT
});

export const listErpsSuccess = (data: any) => ({
  type: LIST_ERPS_SUCCESS,
  payload: data
});

export const createErpInit = (data: any) => ({
  type: CREATE_ERP_INIT,
  payload: data
});

export const createErpSuccess = (data: any) => ({
  type: CREATE_ERP_SUCCESS,
  payload: data
});

export const updateErpInit = (data: any) => ({
  type: UPDATE_ERP_INIT,
  payload: data
});

export const updateErpSuccess = (data: any) => ({
  type: UPDATE_ERP_SUCCESS,
  payload: data
});

export const deleteErpInit = (data: any) => ({
  type: DELETE_ERP_INIT,
  payload: data
});

export const deleteErpSuccess = (data: any) => ({
  type: DELETE_ERP_SUCCESS,
  payload: data
});

export const addErpVersaoInit = (data: any) => ({
  type: ADD_ERP_VERSAO_INIT,
  payload: data
});

export const addErpVersaoSuccess = (data: any) => ({
  type: ADD_ERP_VERSAO_SUCCESS,
  payload: data
});

export const requestErrorErps = (data: any) => ({
  type: ERPS_ERROR_MSG,
  payload: data
});

export const clearFlagsErps = () => ({
  type: CLEAR_FLAGS_ERPS
});
